import { render, staticRenderFns } from "./BaseSelectField.vue?vue&type=template&id=96b43150&scoped=true&"
import script from "./BaseSelectField.vue?vue&type=script&lang=js&"
export * from "./BaseSelectField.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectField.vue?vue&type=style&index=0&id=96b43150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b43150",
  null
  
)

export default component.exports